import log, { LogLevelDesc } from "loglevel";

const level = (import.meta.env.VITE_LOG_LEVEL || "info") as LogLevelDesc;
log.setLevel(level);
log.setDefaultLevel(level);
